import { z } from "zod";

import { zSchema } from "../../../../entity";

const zOut = z.array(zSchema);
type Out = z.infer<typeof zOut>;

export { zOut };
export type { Out };
